
import { getTopPlayers, getFlopPlayers} from '../../../entities/player.js';

export const scope = 'TOP_FLOP';

export function fetchTopPlayersIfNeeded(payload) {
    return (dispatch, getState) => {
        const topflop = getState().app.tools.topflop;

        if (!topflop.info.isFetching)
            dispatch(getTopPlayers(payload, scope));
    };
}

export function fetchFlopPlayersIfNeeded(payload) {
    return (dispatch, getState) => {
        const topflop = getState().app.tools.topflop;

        if (!topflop.info.isFetching)
            dispatch(getFlopPlayers(payload, scope));
    };
}



// WEBPACK FOOTER //
// ./src/actions/app/tools/topflop/index.js